import React, { PropsWithChildren, ReactNode } from 'react';
import { Box } from '@mui/material';
import PageHeader from '../components/PageHeader';
import PageLoadingSpinner from '../components/PageLoadingSpinner';

interface DashboardPageProps extends PropsWithChildren {
  title: string;
  headerChildren?: ReactNode;
  isLoading?: boolean;
}

export default (props: DashboardPageProps) => (
  <Box>
    <PageHeader title={props.title}>
      {props.headerChildren}
    </PageHeader>
    {props.isLoading ? <PageLoadingSpinner /> : props.children}
  </Box>
);
